"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const http_response_1 = require("../http/http-response");
class DefaultHttpClient {
    constructor(options) {
        this.options = options;
        this.instance = axios_1.default.create(this.options);
    }
    request(options) {
        return this.instance
            .request(options)
            .then((response) => this.handleResponse(response, { options }));
    }
    get(url, options) {
        return this.instance
            .get(url, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    delete(url, options) {
        return this.instance
            .delete(url, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    head(url, options) {
        return this.instance
            .head(url, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    post(url, data, options) {
        return this.instance
            .post(url, data, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    put(url, data, options) {
        return this.instance
            .put(url, data, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    patch(url, data, options) {
        return this.instance
            .patch(url, data, options)
            .then((response) => this.handleResponse(response, { url, options }));
    }
    handleResponse(response, { url, options }) {
        if (response) {
            const { data, ...rest } = response;
            return new http_response_1.HttpResponse({ body: data, ...rest });
        }
        else {
            options === null || options === void 0 ? true : delete options.headers;
            console.error(`response ${url} from is empty. Options: ${JSON.stringify(options)}`);
            return new http_response_1.HttpResponse({ body: {} });
        }
    }
}
exports.DefaultHttpClient = DefaultHttpClient;
//# sourceMappingURL=default-http.client.js.map